import React from 'react';
import './Header.scss';
import { scroller } from 'react-scroll';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Header = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const logoOriginal = '/assets/Logos/svg-logo-velasur.svg';

  // Función unificada para manejar navegación y cierre de menú
  const handleMenu = (e, target) => {
    if (e) e.preventDefault();

    // 1. LÓGICA DE NAVEGACIÓN (Si hay un destino)
    if (target) {
      if (target.startsWith('#')) {
        const sectionId = target.slice(1);
        
        // --- LÓGICA DE ANCLA INTERNA ---
        if (window.location.pathname === '/') {
          // Si ya estamos en el inicio, solo hacemos scroll
          scroller.scrollTo(sectionId, { 
            smooth: true, 
            duration: 700,
            offset: -75 
          });
        } else {
          // Si estamos en otra página, navegamos al inicio con el hash
          navigate('/');
          // Esperamos a que cargue la página principal para scrollear
          setTimeout(() => {
            scroller.scrollTo(sectionId, { 
              smooth: true, 
              duration: 700,
              offset: -75 
            });
          }, 400); // 400ms para permitir que React Router cambie la vista
        }
      } else {
        // --- LÓGICA DE RUTA NORMAL ---
        navigate(target);
      }
    }

    // 2. LÓGICA DEL MENÚ MÓVIL (Abrir/Cerrar)
    if (window.innerWidth < 1024) {
      if (!target) {
        // Si NO hay target (clic en la hamburguesa), abrimos/cerramos (Toggle)
        props.setOpen(props.open === 'menu-open' ? '' : 'menu-open');
      } else {
        // Si SÍ hay target (clic en una opción del menú), cerramos el menú
        props.setOpen('');
      }
    }
  };

  const toggleLanguage = () => {
    const nextLanguage = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(nextLanguage);
  };

  return (
    <header className={`header ${props.open ? props.open : ''}`}>
      <div className='icon_menu'>
        {/* Aquí NO pasamos target, por lo que entra al Toggle del menú */}
        <p className='btn-toggle' onClick={(e) => handleMenu(e)}>
          <span></span>
        </p>
        <p>{t('header.menu')}</p>
      </div>

      <div className='icon_logo'>
        <a href='/' onClick={(e) => handleMenu(e, '/')}>
          <img src={logoOriginal} alt='logo' />
        </a>
      </div>

      <div className='telefono'>
        <a
          href='tel:+524428801675'
          target="_blank"
          rel="noopener noreferrer"
        >
          {i18n.language === 'en'
            ? 'T. +52 (442) 880 1675'
            : t('header.phone', { phone: '(442) 880 1675', prefix: 'T.' })}
        </a>
      </div>

      <nav className='menu'>
        <ul>
          <li>
            <a href='#concepto' onClick={(e) => handleMenu(e, '#concepto')}>
              {t('header.concept')}
            </a>
          </li>

          <li>
            <a href='#availability' onClick={(e) => e.preventDefault()}>
              {t('header.availability')}
            </a>
            <ul>
              <li><a href='/privada-acacia' onClick={(e) => handleMenu(e, '/privada-acacia')}>{t('header.privadaAcacia')}</a></li>
              <li><a href='/privada-artemisa' onClick={(e) => handleMenu(e, '/privada-artemisa')}>{t('header.privadaArtemisa')}</a></li>
            </ul>
          </li>

          <li>
            <a href='#masterplan' onClick={(e) => handleMenu(e, '#masterplan')}>
              {t('header.macroproject')}
            </a>
          </li>

          <li>
            <a href='/casas-velasur' onClick={(e) => handleMenu(e, '/casas-velasur')}>
              {t('header.houses')}
            </a>
          </li>
          <li>
            <a href='#ubicacion' onClick={(e) => handleMenu(e, '#ubicacion')}>
              {t('header.location')}
            </a>
          </li>
          <li>
            <a href='https://grupovelas.com.mx/' target='_blank' rel='noreferrer'>
              <img
                src='/assets/Logos/svg-logo-grupo-velas.svg'
                alt={t('header.grupoVelasAlt')}
              />
            </a>
          </li>
        </ul>
      </nav>

      <div className='social-media'>
        <a href='https://api.whatsapp.com/send?phone=524461340798' target='_blank' rel='noreferrer'>
          <img src='/assets/Logos/svg-icon-whatsapp.svg' alt='whatsapp' />
        </a>
        <a href='https://www.facebook.com/Velasur-by-Grupo-Velas-100278439225721/' target='_blank' rel='noreferrer'>
          <img src='/assets/Logos/svg-icon-facebook.svg' alt='facebook' />
        </a>
        <a href='https://instagram.com/velasur_qro?utm_medium=copy_link' target='_blank' rel='noreferrer'>
          <img src='/assets/Logos/svg-icon-instagram.svg' alt='instagram' />
        </a>
        <a href="https://www.tiktok.com/@velasur.grupovelas" target='_blank' rel='noreferrer'>
          <img src="/assets/Logos/TikTok.png" alt="TikTok" />
        </a>
      </div>

      <div className='language-switcher'>
        <button onClick={toggleLanguage}>
          {i18n.language === 'es' ? 'EN' : 'ES'}
        </button>
      </div>
    </header>
  );
};

export default Header;